import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  size = 'lg',
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  const box = tone === 'dark' ? 'bg-rink-card text-amber border-rink-line' : 'bg-white text-rink border-ice-dark';
  const label = tone === 'dark' ? 'text-white/60' : 'text-ink-muted';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-104" data-mp="3259hp0xtx7tx">
      {units.map(unit => <div key={unit.label} className={`rounded-card border text-center tabular-nums ${box} ${isLarge ? 'px-4 py-3 sm:px-6 sm:py-4 min-w-[74px] sm:min-w-[92px]' : 'px-3 py-2 min-w-[58px]'}`} data-id="element-105" data-mp="15bg52fpe9d8t">
          <div className={`font-display font-bold leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-2xl'}`} data-id="element-106" data-mp="szzcd8s3r2iz">
            {unit.value}
          </div>
          <div className={`uppercase tracking-widest mt-1 font-semibold ${label} ${isLarge ? 'text-[10px]' : 'text-[9px]'}`} data-id="element-107" data-mp="12seuc63efr3v">
            {unit.label}
          </div>
        </div>)}
    </div>;
}